import { useNavigate } from "react-router-dom";

const StartTourButton = () => {
  const navigate = useNavigate();

  const startTourAgain = () => {
    // Show welcome popup again
    sessionStorage.setItem("show-tour-welcome", "true");

    // Ensure tour doesn't start automatically
    sessionStorage.removeItem("sam-auto-tour");

    navigate("/admin/default");
  };

  return (
    <button onClick={startTourAgain}>
      Start Tour
    </button>
  );
};

export default StartTourButton;